<template>
  <div style="width:100%; height:100%; position:absolute; z-index: 5">
    <!-- use svg to highlight  -->
    <svg :id="hoverableId" :key="hoverableId" :ref="hoverableId" class="hoverable-svg"
         style="position: absolute" width="100%" height="100%" version="1.1"
         xmlns="http://www.w3.org/2000/svg" v-on:mousemove="updateCoordinates" @click="handleClickOnSVG">
      <g v-for="hoverable in hoverableItems"
         v-if="!hoverable.hasOwnProperty('scenes')  || hoverable.scenes.indexOf(scene) !== -1">
        <polygon v-if="hoverable.hasOwnProperty('points')"
                 :points="hoverable.points"

                 class="hoverable"  :id="hoverable.id"
                 :transform="hoverable.transform"
                 v-bind:class="{ 
                'disabled': hoverable.disabled,
                'no-highlight': hoverable.disabled || hoverable.noHover,
                'no-active': hoverable.disabled || hoverable.noActive,
                'debug': hoverable.debug || debug }"
                 @mouseover="handleMouseOver(hoverable, $event)"
                 @mouseout="handleMouseOut(hoverable, $event)"
                 @click="handleHoverableClick(hoverable, $event)">
        </polygon>
        <circle v-else-if="hoverable.hasOwnProperty('circle')"
                :cx="hoverable.circle.cx" :cy="hoverable.circle.cy" :r="hoverable.circle.r"

                class="hoverable"  :id="hoverable.id"
                :transform="hoverable.transform"
                v-bind:class="{ 
                'disabled': hoverable.disabled,
                'no-highlight': hoverable.disabled || hoverable.noHover,
                'no-active': hoverable.disabled || hoverable.noActive,
                'debug': hoverable.debug || debug }"
                @mouseover="handleMouseOver(hoverable, $event)"
                @mouseout="handleMouseOut(hoverable, $event)"
                @click="handleHoverableClick(hoverable, $event)">
        </circle>
        <ellipse v-else-if="hoverable.hasOwnProperty('ellipse ')"
                 :cx="hoverable.ellipse.cx" :cy="hoverable.ellipse.cy"
                 :rx="hoverable.ellipse.rx" :ry="hoverable.ellipse.ry"

                 class="hoverable"  :id="hoverable.id"
                 :transform="hoverable.transform"
                 v-bind:class="{ 
                'disabled': hoverable.disabled,
                'no-highlight': hoverable.disabled || hoverable.noHover,
                'no-active': hoverable.disabled || hoverable.noActive,
                'debug': hoverable.debug || debug }"
                 @mouseover="handleMouseOver(hoverable, $event)"
                 @mouseout="handleMouseOut(hoverable, $event)"
                 @click="handleHoverableClick(hoverable, $event)">
        </ellipse>
        <rect v-else-if="hoverable.hasOwnProperty('rect')"
              :x="hoverable.rect.x" :y="hoverable.rect.y"
              :rx="hoverable.rect.rx" :ry="hoverable.rect.ry"
              :height="hoverable.rect.height" :width="hoverable.rect.width"

              class="hoverable"  :id="hoverable.id"
              :transform="hoverable.transform"
              v-bind:class="{ 
                'disabled': hoverable.disabled,
                'no-highlight': hoverable.disabled || hoverable.noHover,
                'no-active': hoverable.disabled || hoverable.noActive,
                'debug': hoverable.debug || debug }"
              @mouseover="handleMouseOver(hoverable, $event)"
              @mouseout="handleMouseOut(hoverable, $event)"
              @touchstart="handleTouchStart(hoverable, $event)"
              @click="handleHoverableClick(hoverable, $event)">
        </rect>
        <path v-else-if="hoverable.hasOwnProperty('d')"
              :d="hoverable.d"

              class="hoverable"  :id="hoverable.id"
              :transform="hoverable.transform"
              v-bind:class="{ 
                'disabled': hoverable.disabled,
                'no-highlight': hoverable.disabled || hoverable.noHover,
                'no-active': hoverable.disabled || hoverable.noActive,
                'debug': hoverable.debug || debug }"
              @mouseover="handleMouseOver(hoverable, $event)"
              @mouseout="handleMouseOut(hoverable, $event)"
              @click="handleHoverableClick(hoverable, $event)">

        </path>

        <!-- in debug mode, try to get the LinkTo name display within the hoverable polygon -->
        <text v-if="getAppLevelSetting('debug')===true"
              :x="getFirstXY(hoverable)[0]" :y="getFirstXY(hoverable)[1]"
              font-family="Verdana" font-size="25" fill="purple"  text-anchor="middle">{{hoverable.linkTo}}</text>
      </g>
    </svg>

    <section v-if="false">
      <!-- get coordinate -->
      <p id="coords" style="color: white; font-size: 30px; z-index: 5;position: absolute; bottom: 0px"
         @click="printCoord">{{coords}}</p>
      <p style="color: white; font-size: 30px; z-index: 5;position: absolute; bottom: 0px ; right: 0px">
        {{x}},{{y}}</p>
    </section>
  </div>
</template>
<script>
  import { EventBus } from '../assets/js/event-bus';

  /**
   https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Basic_Shapes

   Define hoverable area in Config.json
   "rect"  : { "x"=10, "y"=10, "width"=30, "height"=30 }
   "rect"  : { "x"=60, "y"=10, "rx"=10, "ry"=10, "width"=30, "height"=30 }
   "circle" : { "cx":25, "cy":75, "r":20}
   "ellipse" : { "cx":25, "cy":75, "rx":20, "ry":30}
   "points" : "50 160 55 180 70 180 60 190 65 205 50 195 35 205 40 190 30 180 45 180"

   section - int of the current section of hoverable svg
             ie. if set to 1, then only polygon with section one would be turned ON.

   noHover - no hover over effect, thus no-highlight
   noActive - no click effect when selected.
   */


  export default {
    components: {},
    name: 'hoverable-svg',
    props: {
      hoverableItems: {
        type: Array,
        required: true,
      },
      hoverableId: {
        type: String,
        required: true,
      },
      scene: {
        required: false,
      },
    },
    mounted() {
      if (window.debug) {
        this.debug = true;
      }
      EventBus.$on('hoverable-close-modal', this.handleCloseModal);
    },
    data() {
      return {
        isTouchEvent: false,
        x: 0,
        y: 0,
        coords: '',
        debug: false,
      };
    },
    methods: {
      belongToScene(hoverable) {
        // If scene is not defined, then it should be in all scene
        // if scene is defined, then we need to compare it with the current scene.
        // Scene is the current page under the same hoverable svg.

        // ie. I have one hoverable svg, and on that page, we have 4 scenes where
        // the page content can switch between the scenes and the hoverable element
        // will get enable/disable based on the scene.
        // See Reservoir AppDash
        let belongToScene;
        if (!hoverable.hasOwnProperty('scenes')) {
          // console.log('scenes not defined');
          belongToScene = true;
        } else if (hoverable.scenes.indexOf(this.scene) !== -1) {
          // debugger;
          // console.log(`${hoverable.scenes} belongs to ${this.scene}`);
          belongToScene = true;
        } else {
          // console.log(`${hoverable.scenes} not belongs to ${this.scene}`);
          belongToScene = false;
        }

        return belongToScene;
      },
      getFirstXY(hoverable) {
        // debugger;
        if (hoverable.hasOwnProperty('points')) {
          return hoverable.points.trim().split(/\s+/)[0].split(',');
        } else if (hoverable.hasOwnProperty('rect')) {
          return [hoverable.rect.x, hoverable.rect.y];
        } else if (hoverable.hasOwnProperty('circle')) {
          return [hoverable.circle.cx + hoverable.circle.r, hoverable.circle.cy + (hoverable.circle.r)];
        } else if (hoverable.hasOwnProperty('circle')) {
          return [hoverable.ellipse.cx, hoverable.ellipse.cy];
        } else if (hoverable.hasOwnProperty('d')) {
          // d: "M 780,1432 H468c-0.5 (always starts with M XXX,XXX
          return hoverable.d.split(/\s+/)[1].split(',');
        }
      },
      /**
       * When modal on page needs to be closed
       * i.e Video player is activated, then modal needs to be closed
       */
      handleCloseModal() {
        this.$emit('hoverable-close-modal');
      },

      /**
       * This is use when hover on element A, we also want to hover
       * element B.
       * hoverable.id = "hv-circle"  SVG element A
       * hoverable.group: ["hv-circle"],  SVG element B
       */
      setHoverStateForEleId(id, enable) {
        const ele = document.querySelector(`#${id}`);
        if (ele) {
          if (enable) {
            ele.classList.add('hover-group');
          } else {
            ele.classList.remove('hover-group');
          }
        }
      },
      handleTouchStart(hoverable, e) {
        // add class to not react to hover effect
        // This is to resolve sticky hover effect on touch screen
        // adding class touch device to element will remove
        // hover effect.
        /**
         *
         According to https://www.html5rocks.com/en/mobile/touchandmouse/
         For a single click the order of events is:

         touchstart  - add touch device class to prevent hover effect, then set isTouchDevice to true
         touchmove
         touchend
         mouseover   - reset touch-device if it is a NORMAL MOUSE OVER
         mousemove
         mousedown
         mouseup
         click       - reset isTouchDevice to false, so normal mouse event would work
         */
        e.target.classList.add('touch-device');
        this.isTouchEvent = true;
      },
      /**
       * Set Mouse Over behavior for the current hoverable.
       */
      handleMouseOver(hoverable, e) {
        // If this event is triggered by a touch event, then
        // don't remove the touch-device class. Else, this
        // is a normal mouse event, thus remove the touch-device
        // class from element, so it can have properly hover effect
        if (!this.isTouchEvent) {
          e.target.classList.remove('touch-device');
        }
        if (typeof hoverable.group !== 'undefined') {
          hoverable.group.forEach((value, index, array) => {
            this.setHoverStateForEleId(value, true);
          });
        }
      },
      handleMouseOut(hoverable, e) {
        if (typeof hoverable.group !== 'undefined') {
          hoverable.group.forEach((value, index, array) => {
            this.setHoverStateForEleId(value, false);
          });
        }
      },
      /**
       * This handle any defined hoverable svg within the component.
       * @param hoverable
       * @param e
       */
      handleHoverableClick(hoverable, e) {
        /**
         * Stop the event from bubbling up
         */
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();

        this.isTouchEvent = false;

        // hoverable.disabled is set in config.json
        // classList contains diaabled is set via javascript
        if (typeof hoverable !== 'undefined'
          && !e.target.classList.contains('disabled')
          && (!hoverable.disabled
            || hoverable.disabled === false)) {
          /**
           * Custom and modal should be handle by the View,
           * Everything will be handle globally
           */
          // debugger;
          if (typeof hoverable.custom !== 'undefined') {
            // have custom function which require caller to subscribe
            // to require-custom-function event
            this.$emit('require-custom-function', hoverable.custom);
          } else if (hoverable.modal) {
            this.$emit('hoverable-clicked-modal', hoverable.modal);
          } else {
            this.handleClickWithGlobalComponents(hoverable);
          }
        }

        // this.$nextTick(()=>{
        //   e.target.classList.remove('touch-device');
        // });
      },
      /**
       * handle all click outside of defined hoverable-svg.
       * i.e the entire SVG except for hoverable-svg
       * @param event
       */
      handleClickOnSVG(event) {
        // for getting the coordinate of a click in screen
        this.recordCoord(event);
        this.$emit('handle-click-on-hoverable-svg');
      },
      handleClickWithGlobalComponents(hoverable) {
        EventBus.$emit('hoverable-clicked-event', hoverable);
      },
      updateCoordinates(event) {
        this.x = event.clientX;
        this.y = event.clientY;
      },
      recordCoord(event) {
        this.coords = `${this.coords} ${this.x},${this.y} `;
      },
      printCoord() {
        // console.log(this.coords);
        // console.log('Record new set of coords')
        this.coords = '';

        this.copyToClipboard('#coords');
      },
      copyToClipboard(element) {
        // debugger;
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val($(element).text().trim()).select();
        document.execCommand("copy");
        $temp.remove();
      },
      setEnableSVGEleId(id, enable) {
        // debugger;
        const ele = document.querySelector(`#${id}`);
        if (ele) {
          this.setEnableSVGEle(ele, enable);
        }
      },
      setEnableSVGEle(ele, enable) {
        if (enable) {
          ele.classList.remove('no-highlight');
          ele.classList.remove('no-active');
          ele.classList.remove('disabled');
        } else {
          ele.classList.add('no-highlight');
          ele.classList.add('no-active');
          ele.classList.add('disabled');
        }
      },
      setEnableSVG(enable) {
        this.$refs[this.hoverableId].style.display = enable ? '' : 'none';
      },
    },
  };
</script>

<style lang="css" rel="stylesheet/css scoped">
  .debug {
    stroke: red !important;
  }

  .debugLinkTo{

  }
  .hoverable {
    fill: transparent;
    /* unocmment to debug the hoverable area  */
    stroke: none;
    /*stroke: red;*/
    stroke-width: 1px;
    cursor: pointer;
  }

  /**
   Hover effect for the menu
   */
  .hoverable:not(.no-highlight):not(.touch-device):hover,
  .hover-group{
    /*fill: blue;*/
    fill: white;
    /* unocmment to debug the hoverable area  */
    /* stroke: black; */
    stroke: none;
    opacity: 0.15;
  }

  /**
   Clicking effect for the menu
   */
  .hoverable:not(.no-active):active{
    fill: white;
    /*fill: red;*/
    /* unocmment to debug the hoverable area  */
    stroke: yellowgreen;
    /*stroke: none;*/
    opacity: 0.3;
  }

  .disabled {
    cursor: inherit !important;
  }
</style>



// WEBPACK FOOTER //
// Hoverable-SVG.vue?ae11e48c